import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../services/home.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css'],
})
export class CategoryComponent {
  categories: any[] = [];
  constructor(private router:Router,private homeService:HomeService){}

  ngOnInit(){
    this.homeService.getCategories().subscribe((res)=>{
      this.categories = res.map((category)=>{
        return {name: category.name,
         img:category.imageUrl
          ? environment.apiUrl + category.imageUrl
          : 'assets/img/jersey.png'}
      })
    })
  }

  goToProductsByCategory(categoryName: string) {
  this.router.navigate(['/products'], { queryParams: { category: categoryName } });
}
  // categories = [
  //   { img: 'assets/img/jersey.png', name: 'JERSEY' },
  //   { img: 'assets/img/shorts.png', name: 'shorts' },
  //   { img: 'assets/img/shoes.png', name: 'JERSEY' },
  //   { img: 'assets/img/socks.png', name: 'socks' },
  // ];
}
